module.exports = __webpack_public_path__ + "static/Mac screen@2x-min1-92101739024c27e75dea51ad618bd8f6.png";